'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".Icon-module_imageWrapper__D3sfS>img{border:0;display:block;line-height:0;margin:0;padding:0}";
var styles = {"imageWrapper":"Icon-module_imageWrapper__D3sfS"};
styleInject["default"](css_248z, '9b5b66e2-082d-431f-bc6a-da59efafcef1');

exports["default"] = styles;
